import { VideoEditor } from '../VideoEditor';
import { Element } from '../models/Element';
import { VideoEditorLogger } from '../../utility/VideoEditorLogger';
import { TimelineMode } from './TimelineMode';
import { AbstractLayoutCommand } from './AbstractLayoutCommand';

export interface TrimLayoutElementsParameters {
  trimType: 'start' | 'end';
  trimTime: number;
}

export class TrimLayoutElementsCommand extends AbstractLayoutCommand {
  private params: TrimLayoutElementsParameters;

  constructor(
    editor: VideoEditor,
    element: Element,
    params: TrimLayoutElementsParameters,
  ) {
    super(editor, element);
    this.params = params;
  }

  execute(): boolean {
    if (!this.sourceElement) {
      VideoEditorLogger.logCommand(this, 'error', {
        error: 'No source element provided',
      });
      return false;
    }

    super.execute(); // makes a snapshot

    const elements = this.pickAllLayoutElements(this.sourceElement);
    if (!elements) {
      VideoEditorLogger.logCommand(this, 'error', {
        error: 'Failed to trim: no parent found or not a layout element',
      });
      return false;
    }
    const { parent: parentElement, children: childrenElements } = elements;

    // Trim all elements
    for (const childElement of childrenElements) {
      if (!this.doTrim(childElement, TimelineMode.DEFAULT)) {
        return false;
      }
    }
    if (!this.doTrim(parentElement, TimelineMode.RIPPLE)) {
      return false;
    }

    this.canUndo = true;

    return true;
  }

  getDescription(): string {
    return `Trim layout elements (${this.params.trimType}) at ${this.params.trimTime}s`;
  }

  doTrim(element: Element, timelineMode: TimelineMode): boolean {
    const { trimTime, trimType } = this.params;
    if (trimType === 'start') {
      return this.editor
        .getTrackManager()
        .trimMediaStart(element, trimTime, timelineMode, false);
    } else {
      return this.editor
        .getTrackManager()
        .trimElementEnd(element, trimTime, timelineMode, false);
    }
  }
}
